import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import { ELEMENT_COLORS, ELEMENT_ICONS, BONUS_EFFECT_COLORS, BONUS_EFFECT_ICONS, BONUS_EFFECT_LABELS, BONUS_COLOR, formatBonusDescription, getCardBackImage } from '../../common';
import parsePostContent from '../../common/helpers/parsePostContent';
import attachCardTilt from '../../common/helpers/attachCardTilt';
import userById from '../../common/helpers/userById';
// Elemental card face — structurally identical to CardComponent's elemental view.

function elementalCardFace(side, cardBackImage) {
  const color = ELEMENT_COLORS[side.card.element] || '#888';
  const icon = ELEMENT_ICONS[side.card.element] || 'fas fa-question';
  const elementLabel = app.translator.trans("forumaker-arena.lib.elements.".concat(side.card.element)) || side.card.element;
  return m("div", {
    className: "ArenaCard ArenaCard--elemental ArenaCard--full",
    style: {
      '--element-color': color
    },
    oncreate: vnode => {
      vnode.dom._detachTilt = attachCardTilt(vnode.dom);
    },
    onremove: vnode => {
      var _detachTilt, _ref;
      (_detachTilt = (_ref = vnode.dom)._detachTilt) == null || _detachTilt.call(_ref);
    }
  }, m("div", {
    className: "ArenaCard-header".concat(cardBackImage ? ' ArenaCard-header--skinned' : ''),
    style: cardBackImage ? {
      backgroundImage: "url(".concat(cardBackImage, ")")
    } : {
      backgroundColor: color
    }
  }, m("div", {
    className: "ArenaCard-avatar"
  }, side.card.imageUrl ? m("img", {
    src: side.card.imageUrl,
    alt: side.card.name
  }) : m("i", {
    className: icon
  }))), m("div", {
    className: "ArenaCard-body"
  }, m("div", {
    className: "ArenaCard-name"
  }, side.card.name), side.card.description && m("div", {
    className: "ArenaCard-description"
  }, side.card.description), m("div", {
    className: "ArenaCard-footer"
  }, m("div", {
    className: "ArenaCard-bonusTag"
  }, m("i", {
    className: icon,
    style: {
      color
    }
  }), " ", elementLabel, side.bonus > 0 && m("span", {
    className: "ArenaTurnPost-bonus"
  }, "+", side.bonus)), m("div", {
    className: "ArenaCard-stats"
  }, m("span", {
    className: "ArenaCard-stat ArenaCard-stat--attack"
  }, m("i", {
    className: "fas fa-axe-battle"
  }), m("span", null, side.card.attack)), m("span", {
    className: "ArenaCard-stat ArenaCard-stat--defense"
  }, m("i", {
    className: "fas fa-shield-alt"
  }), m("span", null, side.card.defense)), m("span", {
    className: "ArenaCard-stat ArenaCard-stat--cost"
  }, m("i", {
    className: "fas fa-gem"
  }), m("span", null, side.card.cost))))));
}

// Bonus card face — structurally identical to CardComponent's bonus view.

function bonusCardFace(bc, cardBackImage) {
  const color = BONUS_EFFECT_COLORS[bc.bonusEffect] || BONUS_COLOR;
  const icon = BONUS_EFFECT_ICONS[bc.bonusEffect] || 'fas fa-star';
  const label = app.translator.trans("forumaker-arena.lib.bonus_effects.".concat(bc.bonusEffect)) || BONUS_EFFECT_LABELS[bc.bonusEffect] || app.translator.trans('forumaker-arena.forum.battle_turn.bonus_fallback');
  const desc = bc.description || formatBonusDescription(bc.bonusEffect, bc.bonusValue);
  return m("div", {
    className: "ArenaCard ArenaCard--bonus ArenaCard--full",
    style: {
      '--element-color': color
    },
    oncreate: vnode => {
      vnode.dom._detachTilt = attachCardTilt(vnode.dom);
    },
    onremove: vnode => {
      var _detachTilt2, _ref2;
      (_detachTilt2 = (_ref2 = vnode.dom)._detachTilt) == null || _detachTilt2.call(_ref2);
    }
  }, m("div", {
    className: "ArenaCard-header ArenaCard-header--bonus".concat(cardBackImage ? ' ArenaCard-header--skinned' : ''),
    style: cardBackImage ? {
      backgroundImage: "url(".concat(cardBackImage, ")")
    } : {
      backgroundColor: color
    }
  }, m("div", {
    className: "ArenaCard-avatar"
  }, bc.imageUrl ? m("img", {
    src: bc.imageUrl,
    alt: bc.name
  }) : m("i", {
    className: icon
  }))), m("div", {
    className: "ArenaCard-body ArenaCard-body--bonus"
  }, m("div", {
    className: "ArenaCard-name"
  }, bc.name), desc && m("div", {
    className: "ArenaCard-description ArenaCard-description--bonus"
  }, desc), m("div", {
    className: "ArenaCard-footer"
  }, m("div", {
    className: "ArenaCard-bonusTag"
  }, m("i", {
    className: icon,
    style: {
      color
    }
  }), " ", label, bc.bonusValue !== null && m("span", {
    className: "ArenaTurnPost-bonusValue"
  }, bc.bonusValue)), m("div", {
    className: "ArenaCard-stats"
  }, m("span", {
    className: "ArenaCard-stat ArenaCard-stat--cost"
  }, m("i", {
    className: "fas fa-gem"
  }), m("span", null, bc.cost))))));
}

// Player column: elemental + bonus cards. cardBackImage is this side's OWN
// arenaCardBack preference (see view() below) — each player's revealed cards
// are skinned with whatever card back they picked, same as their hand in
// CardSlider and their face-down card in ArenaBattleWaitPost.
function playerCards(side, name, cardBackImage) {
  return m("div", {
    className: "ArenaTurnPost-playerCol"
  }, m("div", {
    className: "ArenaTurnPost-cardLabel"
  }, m("span", null, name)), m("div", {
    className: "ArenaTurnPost-cardPair"
  }, elementalCardFace(side, cardBackImage), side.bonusCard && bonusCardFace(side.bonusCard, cardBackImage)));
}

// Animated "glass vial" HP/mana indicator: SVG tube with rising bubbles inside
// a static full fill (the % value is conveyed by the label text, not by fill
// height). Ambient bubbles rise continuously; hover triggers an extra burst.

const VIAL_W = 96; // internal SVG coordinate system — do not change
const VIAL_H = 26;
const VIAL_DISPLAY_W = 82; // actual on-screen size; viewBox handles scaling
const VIAL_DISPLAY_H = 22;
const VIAL_Y0 = 1;
const VIAL_Y1 = 25;
const VIAL_FULL_RIGHT = 95; // right inner edge of the tube — fill is always full width
const VIAL_BUBBLE_SPAN = VIAL_Y1 - VIAL_Y0 + 4;
const VIAL_AMBIENT_BUBBLES = 2; // permanent bubbles, rising continuously
const VIAL_BURST_BUBBLES = 3; // extra bubbles spawned briefly on hover
const VIAL_BURST_SPEED = 0.02; // faster than ambient — rise and fade within one pass
const VIAL_BURST_LIFETIME = VIAL_BUBBLE_SPAN / VIAL_BURST_SPEED + 100;
let arenaVialIdSeq = 0;
function makeVialBubble(phase, expiresAt) {
  return {
    x: 4 + Math.random() * (VIAL_FULL_RIGHT - 8),
    speed: expiresAt ? VIAL_BURST_SPEED : 0.006 + Math.random() * 0.005,
    phase,
    sway: 0.6 + Math.random() * 0.5,
    expiresAt
  };
}
function spawnVialBubble(state, t0, expiresAt) {
  const el = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  el.setAttribute('class', 'ArenaVial-bubble');
  el.setAttribute('r', (0.9 + Math.random() * 0.7).toFixed(2));
  state.bubbleGroup.appendChild(el);
  // phase is set so the bubble starts rising from the bottom right now
  const phase = expiresAt ? -(performance.now() - t0) : Math.random() * 1000;
  state.bubbles.push(_objectSpread({
    el
  }, makeVialBubble(phase, expiresAt)));
}
function vialFrame(t0, state) {
  const now = performance.now();
  const t = now - t0;
  for (let i = state.bubbles.length - 1; i >= 0; i--) {
    const b = state.bubbles[i];
    if (b.expiresAt && now > b.expiresAt) {
      b.el.remove();
      state.bubbles.splice(i, 1);
      continue;
    }
    const rise = (t + b.phase) * b.speed % VIAL_BUBBLE_SPAN;
    const by = VIAL_Y1 - rise;
    const bx = Math.min(VIAL_FULL_RIGHT - 3, b.x) + Math.sin((t + b.phase) * 0.004) * b.sway;
    const fade = by < VIAL_Y0 + 4 ? Math.max(0, (by - VIAL_Y0) / 4) : 1;
    b.el.setAttribute('cx', bx.toFixed(2));
    b.el.setAttribute('cy', by.toFixed(2));
    b.el.setAttribute('opacity', (0.55 * fade).toFixed(2));
  }
  state.raf = requestAnimationFrame(() => vialFrame(t0, state));
}
function vitalVial(kind, icon, label) {
  const clipId = "arena-vial-clip-".concat(++arenaVialIdSeq);
  return m("span", {
    className: "ArenaVial ArenaVial--".concat(kind),
    oncreate: vnode => {
      const root = vnode.dom;
      const bubbleGroup = root.querySelector('.ArenaVial-bubbles');
      if (!bubbleGroup) return;
      const t0 = performance.now();
      const state = {
        raf: 0,
        bubbles: [],
        bubbleGroup
      };
      for (let i = 0; i < VIAL_AMBIENT_BUBBLES; i++) spawnVialBubble(state, t0);
      state.raf = requestAnimationFrame(() => vialFrame(t0, state));
      root.addEventListener('pointerenter', () => {
        const expiresAt = performance.now() + VIAL_BURST_LIFETIME;
        for (let i = 0; i < VIAL_BURST_BUBBLES; i++) spawnVialBubble(state, t0, expiresAt);
      });
      root._arenaVialState = state;
    },
    onremove: vnode => {
      const state = vnode.dom._arenaVialState;
      if (state != null && state.raf) cancelAnimationFrame(state.raf);
    }
  }, m("svg", {
    viewBox: "0 0 ".concat(VIAL_W, " ").concat(VIAL_H),
    width: VIAL_DISPLAY_W,
    height: VIAL_DISPLAY_H,
    className: "ArenaVial-svg",
    "aria-hidden": "true"
  }, m("clipPath", {
    id: clipId
  }, m("rect", {
    x: "1",
    y: "1",
    width: "94",
    height: "24",
    rx: "12"
  })), m("g", {
    "clip-path": "url(#".concat(clipId, ")")
  }, m("rect", {
    className: "ArenaVial-base",
    x: "1",
    y: "1",
    width: "94",
    height: "24"
  }), m("g", {
    className: "ArenaVial-bubbles"
  }))), m("span", {
    className: "ArenaVial-label"
  }, m("i", {
    className: icon
  }), " ", label));
}
function hpBadge(hp, maxHp) {
  var _ref3;
  const max = (_ref3 = maxHp != null ? maxHp : app.forum.attribute('arenaMaxHp')) != null ? _ref3 : 15;
  return vitalVial('hp', 'fas fa-heart', app.translator.trans('forumaker-arena.forum.battle_turn.stat_fraction', {
    value: hp,
    max
  }));
}
function manaBadge(mana, maxMana) {
  var _ref4;
  const max = (_ref4 = maxMana != null ? maxMana : app.forum.attribute('arenaMaxMana')) != null ? _ref4 : 20;
  return vitalVial('mana', 'fas fa-gem', app.translator.trans('forumaker-arena.forum.battle_turn.stat_fraction', {
    value: mana,
    max
  }));
}

/**
 * Single player tile combining combat stats + effects + HP/mana.
 * attacker = this player (the one attacking); defender = the opponent being
 * defended against. `received` below is the damage this player took, i.e.
 * defender.damageDealt from the defender's perspective.
 */
function playerTile(attacker, defender, playerName, hp, maxHp, mana, effects) {
  var _attacker$breakdown$b, _attacker$breakdown, _defender$breakdown$b, _defender$breakdown;
  const received = defender.damageDealt;
  const gotHit = received > 0;

  // Base card stats (before bonuses). breakdown.baseAttack/baseDefense
  // already reflect swap_stats (see CombatResolver::computeCombatStats) —
  // falling back to the raw card stat only for older posts saved before
  // breakdown tracking existed. Using attacker.card.attack directly here
  // used to ignore swap_stats entirely: when swap lowered the attack, the
  // "bonus" (effectiveAttack - rawAttack) went negative and the `> 0`
  // guard below hid it, so the tile silently showed the pre-swap number
  // with no indication anything had changed.
  const atkBase = (_attacker$breakdown$b = (_attacker$breakdown = attacker.breakdown) == null ? void 0 : _attacker$breakdown.baseAttack) != null ? _attacker$breakdown$b : attacker.card.attack;
  const atkBonus = attacker.effectiveAttack - atkBase;
  const defBase = (_defender$breakdown$b = (_defender$breakdown = defender.breakdown) == null ? void 0 : _defender$breakdown.baseDefense) != null ? _defender$breakdown$b : defender.card.defense;
  const defBonus = defender.effectiveDefense - defBase;
  const compareSymbol = attacker.effectiveAttack > defender.effectiveDefense ? '>' : attacker.effectiveAttack < defender.effectiveDefense ? '<' : '=';
  const b = attacker.breakdown;
  const chips = [];

  // Effects already shown via breakdown chips — skip duplicating them from effectsLog
  const breakdownCovered = new Set();
  if (b) {
    var _b$resonance, _b$sacrifice, _b$involution;
    if (b.element > 0) {
      chips.push(m("span", {
        className: "ArenaTurnPost-chip ArenaTurnPost-chip--element",
        key: "el"
      }, m("i", {
        className: "fas fa-star"
      }), " +", b.element, " ", app.translator.trans('forumaker-arena.forum.battle_turn.chip_element')));
    }
    if (b.surge > 0) {
      chips.push(m("span", {
        className: "ArenaTurnPost-chip ArenaTurnPost-chip--surge",
        key: "surge"
      }, m("i", {
        className: "fas fa-plus-circle"
      }), " ", app.translator.trans('forumaker-arena.forum.battle_turn.chip_surge', {
        value: String(b.surge)
      })));
      breakdownCovered.add('power_surge');
    }
    if (b.weaken > 0) {
      chips.push(m("span", {
        className: "ArenaTurnPost-chip ArenaTurnPost-chip--weaken",
        key: "weaken"
      }, m("i", {
        className: "fas fa-arrow-down"
      }), " \u2212", b.weaken, " ", app.translator.trans('forumaker-arena.forum.battle_turn.chip_weaken')));
      breakdownCovered.add('weaken_tick');
    }
    if (b.shield > 0) {
      chips.push(m("span", {
        className: "ArenaTurnPost-chip ArenaTurnPost-chip--shield",
        key: "shield"
      }, m("i", {
        className: "fas fa-shield-alt"
      }), " ", app.translator.trans('forumaker-arena.forum.battle_turn.chip_shield', {
        value: String(b.shield)
      })));
      breakdownCovered.add('shield');
    }
    if (((_b$resonance = b.resonance) != null ? _b$resonance : 0) > 0) {
      chips.push(m("span", {
        className: "ArenaTurnPost-chip ArenaTurnPost-chip--resonance",
        key: "resonance"
      }, m("i", {
        className: "fas fa-bolt"
      }), " ", app.translator.trans('forumaker-arena.forum.battle_turn.chip_resonance', {
        value: String(b.resonance)
      })));
      breakdownCovered.add('resonance');
    }
    if (((_b$sacrifice = b.sacrifice) != null ? _b$sacrifice : 0) > 0) {
      chips.push(m("span", {
        className: "ArenaTurnPost-chip ArenaTurnPost-chip--sacrifice",
        key: "sacrifice"
      }, m("i", {
        className: "fas fa-heart-broken"
      }), " ", app.translator.trans('forumaker-arena.forum.battle_turn.chip_sacrifice', {
        value: String(b.sacrifice)
      })));
      breakdownCovered.add('sacrifice_atk');
    }
    if (((_b$involution = b.involution) != null ? _b$involution : 0) > 0) {
      chips.push(m("span", {
        className: "ArenaTurnPost-chip ArenaTurnPost-chip--involution",
        key: "involution"
      }, m("i", {
        className: "fas fa-compress-arrows-alt"
      }), " ", app.translator.trans('forumaker-arena.forum.battle_turn.chip_involution', {
        value: String(b.involution)
      })));
      breakdownCovered.add('involution');
    }
  }
  for (const eff of effects) {
    if (breakdownCovered.has(eff.effect)) continue;
    const icon = EFFECT_ICONS[eff.effect];
    const color = EFFECT_ICON_COLORS[eff.effect];
    const text = EFFECT_TEXTS[eff.effect];
    if (!icon || !text) continue;
    chips.push(m("span", {
      className: "ArenaTurnPost-chip ArenaTurnPost-chip--log",
      key: "log-".concat(eff.effect)
    }, m("i", {
      className: icon,
      style: {
        color
      }
    }), " ", text(eff.value)));
  }
  return m("div", {
    className: "ArenaTurnPost-tile ArenaTurnPost-tile--player".concat(gotHit ? ' ArenaTurnPost-tile--hit' : ' ArenaTurnPost-tile--block')
  }, m("div", {
    className: "ArenaTurnPost-tileHead"
  }, m("span", {
    className: "ArenaTurnPost-tileAttacker"
  }, playerName), hpBadge(hp, maxHp), manaBadge(mana)), m("div", {
    className: "ArenaTurnPost-tileStats"
  }, m("span", {
    className: "ArenaTurnPost-tileStat ArenaTurnPost-tileStat--attack"
  }, m("i", {
    className: "fas fa-axe-battle"
  }), m("span", {
    className: "ArenaTurnPost-tileStatLabel"
  }, app.translator.trans('forumaker-arena.forum.battle_turn.atk_label')), m("span", {
    className: "ArenaTurnPost-tileStatNum"
  }, m("span", {
    className: "ArenaTurnPost-tileStatMain"
  }, atkBase), atkBonus > 0 && m("span", {
    className: "ArenaTurnPost-tileStatMod"
  }, "+ ", atkBonus))), m("span", {
    className: "ArenaTurnPost-tileArrow"
  }, compareSymbol), m("span", {
    className: "ArenaTurnPost-tileStat ArenaTurnPost-tileStat--defense"
  }, m("i", {
    className: "fas fa-shield-alt"
  }), m("span", {
    className: "ArenaTurnPost-tileStatLabel"
  }, app.translator.trans('forumaker-arena.forum.battle_turn.def_label')), m("span", {
    className: "ArenaTurnPost-tileStatNum"
  }, m("span", {
    className: "ArenaTurnPost-tileStatMain"
  }, defBase), defBonus > 0 && m("span", {
    className: "ArenaTurnPost-tileStatMod"
  }, "+ ", defBonus)))), chips.length > 0 && m("div", {
    className: "ArenaTurnPost-tileChips"
  }, chips));
}
const EFFECT_ICONS = {
  dot_damage: 'fas fa-skull-crossbones',
  weaken_tick: 'fas fa-arrow-down',
  power_surge: 'fas fa-plus-circle',
  overload: 'fas fa-crosshairs',
  shield: 'fas fa-shield-alt',
  reflect: 'fas fa-undo-alt',
  heal: 'fas fa-heart',
  regeneration: 'fas fa-tint',
  mana_steal: 'fas fa-hand-holding-water',
  debuff_remove: 'fas fa-broom',
  resonance: 'fas fa-bolt',
  resonance_failed: 'fas fa-bolt',
  sacrifice_atk: 'fas fa-heart-broken',
  sacrifice_heal: 'fas fa-heart',
  swap_stats: 'fas fa-exchange-alt',
  amplify_poison: 'fas fa-angle-double-up',
  amplify_weaken: 'fas fa-angle-double-up',
  elemental_tide: 'fas fa-wave-square',
  elemental_dominance: 'fas fa-crown',
  preparation: 'fas fa-piggy-bank'
};
const EFFECT_ICON_COLORS = {
  dot_damage: 'var(--arena-poison)',
  weaken_tick: 'var(--arena-warning)',
  power_surge: 'var(--arena-surge)',
  overload: 'var(--arena-danger)',
  shield: 'var(--arena-info)',
  reflect: 'var(--arena-neutral)',
  heal: 'var(--arena-success)',
  regeneration: 'var(--arena-regen)',
  mana_steal: 'var(--arena-mana)',
  debuff_remove: 'var(--arena-cleanse)',
  resonance: 'var(--arena-surge)',
  resonance_failed: 'var(--arena-neutral)',
  sacrifice_atk: 'var(--arena-warning)',
  sacrifice_heal: 'var(--arena-success)',
  swap_stats: 'var(--arena-neutral)',
  amplify_poison: 'var(--arena-poison)',
  amplify_weaken: 'var(--arena-warning)',
  elemental_tide: 'var(--arena-surge)',
  elemental_dominance: 'var(--arena-warning)',
  preparation: 'var(--arena-mana)'
};

// Result text shown for the affected player. Locale keys:
// forumaker-arena.forum.battle_turn.effect_result.*
const EFFECT_TEXTS = {
  heal: v => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.heal', {
    value: String(v)
  }),
  shield: v => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.shield', {
    value: String(v)
  }),
  regeneration: v => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.regeneration', {
    value: String(v)
  }),
  dot_damage: v => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.dot_damage', {
    value: String(v)
  }),
  weaken_tick: v => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.weaken_tick', {
    value: String(v)
  }),
  reflect: v => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.reflect', {
    value: String(v)
  }),
  power_surge: v => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.power_surge', {
    value: String(v)
  }),
  debuff_remove: () => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.debuff_remove'),
  overload: v => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.overload', {
    value: String(v)
  }),
  mana_steal: v => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.mana_steal', {
    value: String(v)
  }),
  resonance: v => app.translator.trans('forumaker-arena.forum.battle_turn.chip_resonance', {
    value: String(v)
  }),
  resonance_failed: () => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.resonance_failed'),
  sacrifice_atk: v => app.translator.trans('forumaker-arena.forum.battle_turn.chip_sacrifice', {
    value: String(v)
  }),
  sacrifice_heal: v => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.sacrifice_heal', {
    value: String(v)
  }),
  swap_stats: () => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.swap_stats'),
  amplify_poison: () => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.amplify_poison'),
  amplify_weaken: () => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.amplify_weaken'),
  elemental_tide: v => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.elemental_tide', {
    value: String(v)
  }),
  elemental_dominance: () => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.elemental_dominance'),
  preparation: () => app.translator.trans('forumaker-arena.forum.battle_turn.effect_result.preparation')
};
export default class ArenaBattleTurnPost extends Component {
  view() {
    var _data$challenger, _data$opponent, _userById, _userById2, _userById3, _userById4;
    const data = parsePostContent(this.attrs.post.content());
    const fallback = id => app.translator.trans('forumaker-arena.forum.battle.player_fallback', {
      id: String(id)
    });
    if (!data || !((_data$challenger = data.challenger) != null && _data$challenger.card) || !((_data$opponent = data.opponent) != null && _data$opponent.card)) {
      var _data$turn;
      return m("div", {
        className: "ArenaTurnPost EventPost"
      }, m("div", {
        className: "ArenaTurnPost-tileSection",
        style: {
          padding: '10px 14px',
          color: 'var(--muted-color)',
          fontSize: '.85em'
        }
      }, m("i", {
        className: "fas fa-dungeon",
        style: {
          marginRight: '6px'
        }
      }), app.translator.trans('forumaker-arena.forum.battle_turn.heading', {
        turn: String((_data$turn = data == null ? void 0 : data.turn) != null ? _data$turn : '?')
      })));
    }
    const challenger = data.challenger,
      opponent = data.opponent,
      challengerHp = data.challengerHp,
      opponentHp = data.opponentHp,
      challengerMaxHp = data.challengerMaxHp,
      opponentMaxHp = data.opponentMaxHp,
      challengerMana = data.challengerMana,
      opponentMana = data.opponentMana,
      battleOver = data.battleOver,
      battleOverReason = data.battleOverReason,
      winnerId = data.winnerId,
      _data$effectsLog = data.effectsLog,
      effectsLog = _data$effectsLog === void 0 ? [] : _data$effectsLog;
    const challengerName = ((_userById = userById(challenger.userId)) == null ? void 0 : _userById.displayName()) || fallback(challenger.userId);
    const opponentName = ((_userById2 = userById(opponent.userId)) == null ? void 0 : _userById2.displayName()) || fallback(opponent.userId);

    // Each side's own card back preference — not the viewer's — so both
    // players' revealed cards show correctly regardless of who's looking.
    const challengerBack = getCardBackImage((_userById3 = userById(challenger.userId)) == null ? void 0 : _userById3.attribute('arenaCardBack'));
    const opponentBack = getCardBackImage((_userById4 = userById(opponent.userId)) == null ? void 0 : _userById4.attribute('arenaCardBack'));
    const manaOutName = battleOverReason === 'mana_out' || battleOverReason === 'mana_depleted' ? challengerMana <= 0 ? challengerName : opponentName : null;
    const winnerName = winnerId === challenger.userId ? challengerName : winnerId === opponent.userId ? opponentName : null;
    const loserName = winnerId === challenger.userId ? opponentName : winnerId === opponent.userId ? challengerName : null;
    return m("div", {
      className: "ArenaTurnPost EventPost"
    }, m("div", {
      className: "ArenaTurnPost-cards"
    }, playerCards(challenger, challengerName, challengerBack), m("div", {
      className: "ArenaTurnPost-vs"
    }, "VS"), playerCards(opponent, opponentName, opponentBack)), m("div", {
      className: "ArenaTurnPost-tileGrid"
    }, playerTile(challenger, opponent, challengerName, challengerHp, challengerMaxHp, challengerMana, effectsLog.filter(e => e.side === 'challenger')), playerTile(opponent, challenger, opponentName, opponentHp, opponentMaxHp, opponentMana, effectsLog.filter(e => e.side === 'opponent'))), battleOver && (winnerId === null ? m("div", {
      className: "ArenaFinalPost ArenaFinalPost--draw"
    }, m("div", {
      className: "ArenaFinalPost-icon"
    }, m("i", {
      className: "fas fa-handshake"
    })), m("div", {
      className: "ArenaFinalPost-body"
    }, m("div", {
      className: "ArenaFinalPost-title"
    }, app.translator.trans('forumaker-arena.forum.battle_turn.draw_title')))) : m("div", {
      className: "ArenaFinalPost ArenaFinalPost--win"
    }, m("div", {
      className: "ArenaFinalPost-icon"
    }, m("i", {
      className: "fas fa-trophy"
    })), m("div", {
      className: "ArenaFinalPost-body"
    }, m("div", {
      className: "ArenaFinalPost-title"
    }, app.translator.trans('forumaker-arena.forum.battle_turn.win_title', {
      name: m("strong", null, winnerName != null ? winnerName : '')
    })), m("div", {
      className: "ArenaFinalPost-subtitle"
    }, battleOverReason === 'mana_out' || battleOverReason === 'mana_depleted' ? app.translator.trans('forumaker-arena.forum.battle_turn.mana_out_subtitle', {
      name: manaOutName != null ? manaOutName : ''
    }) : battleOverReason === 'mana_deadlock' ? app.translator.trans('forumaker-arena.forum.battle_turn.mana_deadlock_subtitle', {
      name: loserName != null ? loserName : ''
    }) : battleOverReason === 'turns' || battleOverReason === 'turns_exhausted' ? app.translator.trans('forumaker-arena.forum.battle_turn.turns_out_subtitle', {
      name: loserName != null ? loserName : ''
    }) : app.translator.trans('forumaker-arena.forum.battle_turn.hp_out_subtitle', {
      name: loserName != null ? loserName : ''
    }))))));
  }
}
flarum.reg.add('forumaker-arena', 'forum/components/ArenaBattleTurnPost', ArenaBattleTurnPost);